import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { Issue } from '../issues/components/issue';
import { getCurrentDimensions } from '../shared/hooks/useWindowDimensions';
import { assetPaths } from './assetUtils';
import { Asset } from './components/asset';
import { AssetAlertFormPage } from './components/asset-alert-form-page';
import { AssetRoutineAlerts } from './components/asset-routine-alerts';
import { AssetRoutineSubmit } from './components/asset-routine-submit';
import { AssetRoutines } from './components/asset-routines';
import { AssetRoutinesAll } from './components/asset-routines-all';
import { AssetRoutinesRearrange } from './components/asset-routines-rearrange';
import { AssetActivity } from './components/assetActivity';
import { AssetDetail } from './components/assetDetail';
import { AssetDetailFilter } from './components/assetDetailFilter';
import { AssetFileEdit } from './components/assetFileEdit';
import { AssetFilePreview } from './components/assetFilePreview';
import { AssetFiles } from './components/assetFiles';
import { AssetNew } from './components/assetNew';
import { AssetNewIssue } from './components/assetNewIssue';
import { Assets } from './components/assets';
import { AssetsFilterPage } from './components/assetsFilterPage';
import { EditAsset } from './components/edit';

export const assetsRoutes = [
  {
    path: `${assetPaths.root}/:assetId`,
    element: <Asset />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
    children: [
      {
        path: 'activities/:issueId',
        element: <Issue />,
        loader: () => {
          const dimensions = getCurrentDimensions();
          const maxHeight = (dimensions?.height || 0) - 580;

          return {
            dimensions: dimensions,
            maxHeight: maxHeight,
          };
        },
      },
    ],
  },
  {
    path: assetPaths.root,
    element: <Assets />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: `${assetPaths.root}/filters`,
    element: <AssetsFilterPage />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: `${assetPaths.root}/new`,
    element: <AssetNew />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.create,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/activity/new`,
    element: <AssetNewIssue />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.issue.create,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/routines`,
    element: <AssetRoutines />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/routines/all`,
    element: <AssetRoutinesAll />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/routines/edit`,
    element: <AssetRoutinesRearrange />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.update,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/routines/:routineId`,
    element: <AssetRoutineSubmit />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/routines/:routineId/alerts`,
    element: <AssetRoutineAlerts />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/routines/:routineId/alerts/new`,
    element: <AssetAlertFormPage />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/routines/:routineId/alerts/:alertId/edit`,
    element: <AssetAlertFormPage />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/activity/:issueId`,
    element: <AssetActivity />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/files`,
    element: <AssetFiles />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/files/:mediaId`,
    element: <AssetFilePreview />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/files/:mediaId/edit`,
    element: <AssetFileEdit />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.update,
    },
  },
  {
    path: 'assets/:assetId/detail',
    element: <AssetDetail />,
    handle: {
      header: {
        titleKey: 'topNav.assetDetail',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/detail/filters`,
    element: <AssetDetailFilter />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.read,
    },
  },
  {
    path: 'assets/:assetId/edit',
    element: <EditAsset />,
    handle: {
      header: {
        titleKey: 'topNav.editAsset',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.update,
    },
  },
];
